import { CLIENT_ALWAYS_HIDDEN_COLUMNS } from './BudgetDetailsPanelConfig'

/** Same column visibility rules as BudgetDetailsPanel DataTable. */
export function selectRenderedBudgetColumnDefs(config, forcedHiddenColumns, editingColumns, draftColumns, visibleColumns) {
  if (!config?.columns?.length) return []
  const safeVisible = visibleColumns && typeof visibleColumns === 'object' ? visibleColumns : {}
  const eligibleColumns = config.columns.filter(col => !forcedHiddenColumns[col.key])
  return editingColumns
    ? eligibleColumns
    : eligibleColumns.filter(col => CLIENT_ALWAYS_HIDDEN_COLUMNS.has(col.key) || safeVisible[col.key])
}
